import React, { useState } from 'react'
import {
  Button,
  Grid,
  IconButton,
  Paper,
  Typography,
  Box,
  TextField
} from '@mui/material'
import logo from '../images/AGWE.png'
import fb from '../images/fb.png'
import twitter from '../images/twitter.png'

const ContactUs = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')

  const inspirationAndImpact = (
    <Grid item xs={6}>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            variant='h7'
            component='div'
            style={{
              textAlign: 'center',
              width: '100%',
              // fontFamily: 'emoji'
              fontSize: '7vh',
              color: '#365b6d'
            }}
          >
            <strong>{'CONTACT US'}</strong>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper
            style={{
              padding: '5%',
              marginLeft: '50px',
              marginRight: '50px',
              marginTop: '1vh',
              backgroundColor: '#e2cfc5',
              borderRadius: '10%',
              height: '60vh'
            }}
          >
            <TextField
              label='Name'
              fullWidth={true}
              variant='filled'
              value={name}
              onChange={event => setName(event.target.value)}
              style={{
                backgroundColor: '#ddaa99',
                marginBottom: '5vh',
                marginTop: '5vh',
                fontSize: '5vh'
              }}
            />
            <TextField
              label='Email Address'
              fullWidth={true}
              value={email}
              onChange={event => setEmail(event.target.value)}
              variant='filled'
              style={{ backgroundColor: '#ddaa99', marginBottom: '5vh' }}
            />
            <TextField
              label='Message'
              fullWidth={true}
              value={message}
              variant='filled'
              onChange={event => setMessage(event.target.value)}
              multiline={true}
              rows={10}
              style={{ backgroundColor: '#ddaa99', marginBottom: '2vh' }}
            />

            <Button
              variant={'contained'}
              style={{
                backgroundColor: '#ddaa99',
                color: '#fffdfd',
                marginLeft: '33vh',
                paddingLeft: '5vh',
                paddingRight: '5vh',
                fontSize: '2vh'
              }}
            >
              <strong>Send</strong>
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )

  const aboutUs = (
    <Grid item xs={6} style={{ maxWidth: '50%' }}>
      <Grid container>
        <Grid item xs={12} style={{ marginLeft: '30vh' }}>
          {<img src={logo} alt='' width='400vw' height='400vh'></img>}
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant='h7'
            component='div'
            style={{
              textAlign: 'center',
              width: '100%',
              // fontFamily: 'emoji'
              fontSize: '7vh',
              color: '#365b6d'
            }}
          >
            <strong>{'GET UPDATES'}</strong>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Paper
            style={{
              padding: '5%',
              marginLeft: '10vw',
              marginRight: '10vw',
              marginTop: '1vh',
              backgroundColor: '#e2cfc5',
              borderRadius: '20%',
              height: '16vh'
            }}
          >
            <Grid container>
              <Grid item xs={4} style={{ textAlign: 'end' }}>
                {<img src={fb} alt='' width='90vw' height='80vh'></img>}
              </Grid>
              <Grid item xs={8}>
                <Typography
                  variant='h7'
                  component='div'
                  style={{
                    textAlign: 'start',
                    width: '100%',
                    fontSize: '4vh',
                    color: '#365b6d',
                    marginTop: '2vh'
                  }}
                >
                  <strong>{'FACEBOOK'}</strong>
                </Typography>
              </Grid>
              <Grid item xs={4} style={{ textAlign: 'end' }}>
                {<img src={twitter} alt='' width='84vw' height='74vh'></img>}
              </Grid>

              <Grid item xs={8} style={{ marginTop: '1vh' }}>
                <Typography
                  variant='h7'
                  component='div'
                  style={{
                    textAlign: 'start',
                    width: '100%',
                    fontSize: '4vh',
                    color: '#365b6d'
                  }}
                >
                  <strong>{'TWITTER'}</strong>
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )

  return (
    <>
      <Grid container spacing={1} style={{ margin: '10px' }}>
        {aboutUs}
        {inspirationAndImpact}
      </Grid>
    </>
  )
}

export default ContactUs
